import { SettingsService } from "./../settings.service";
import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { PatientsService } from "../patients.service";
import { Patient } from "../patients/patient";
import { AppointmentsService } from "./../appointments.service";
import { TranslateService } from "@ngx-translate/core";
import { catchError } from "rxjs/operators";
import { of } from "rxjs";
import { duration } from "moment";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { LoginService } from "../login.service";
import { AnalyticsService } from "../analytics.service";
import { CITIES } from "../cities";
interface ActivityHours {
  sunday: any[];
  monday: any[];
  tuesday: any[];
  wednesday: any[];
  thursday: any[];
  friday: any[];
  saturday: any[];
}
@Component({
    selector: "app-appts-by-room-gyn",
    templateUrl: "./appts-by-room-gyn.component.html",
    styleUrls: ["./appts-by-room-gyn.component.scss"],
    standalone: false
})
export class ApptsByRoomGynComponent implements OnInit {
  @ViewChild("messageDiv") messageDiv: ElementRef | undefined;
  @ViewChild("messageGeneral") messageGeneral: ElementRef | undefined;

  message;
  GID;
  ID;
  patient;
  firstName;
  lastName;
  mobile;
  address;
  showFirstName;
  showLastName;
  showMobile;
  showBirth;
  showAddress;
  isObgyn;
  isCardio;
  isGastro;
  isEyes;
  hasSeparation;
  firstScreen = true;
  secondScreen = false;
  showAppointmentsScreen = false;
  endScreen = false;
  examCategory;
  private previousExamCategory: string = "";
  clinicExamTypes = [];
  filterdClinicExamTypeAfterUserSelectCategory = [];
  LMP;
  examTypeSelected;
  doctorSelected;
  clinicUsers = [];
  filteredUsers = [];
  invalidId = false;
  param;
  verification;
  showVerification;
  mobileError = false;
  verificationIndex;
  verificationValid: any = "pending";
  lmpValid = true;
  City;
  Zip;
  hmo;
  clinicPhone;
  idAttemptsCounter = 0;
  codeMobileAttemptsCounter = 0;
  errorReAttempts = false;
  slotsAvailable: any = "pending";
  activityHours = {};
  Fetus;
  Price;
  showMessage = false;
  Message = null;
  msgSaved = false;
  appointments = [];
  popUpMessage = false;
  patActivities = 0;
  popupActivityDeviation = false;
  HMOName;
  Insurance;
  hmoOptions = [];
  showPriceError = false;
  clinicTitle;
  hasCodeAnswer: 'yes' | 'no' | null = null;
  showCodeExampleModal = false;
  examCodeInput: string = '';
  examCodeError: string = '';
  codeValidating: boolean = false;
  PregnancyExams = [];
  GynecologyExams = [];
  FetalEchoExams = [];
  PediatricEchoExams = [];
  CardioExams = [];
  firstExam;
  isFirstExamAnswered: boolean = false;
  firstExamRequired;
  prevExamHmo;
  isPrevExamHmoAnswered;
  isprevExamHmoRefundAnswered;
  prevExamHmoRefund;
  showMessageGeneral = false;
  altHeader: SafeHtml;
  showHeader = false;
  onlyMessage = false;
  maxDate: Date = new Date();
  existingAppointmentMsg: string = "";
  showExistingAppointmentMsg: boolean = false;
  consentGiven: any;
  birthDate = null;
  consentYes: boolean = true;
  consentNo: boolean = false;
  showSmsConsent: boolean = true;
  cities: string[] = [];
  filteredCities: string[] = [];
  citySearchInput: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private PatientsService: PatientsService,
    public SettingsService: SettingsService,
    public appointmentService: AppointmentsService,
    public translate: TranslateService,
    private sanitizer: DomSanitizer,
    public loginService: LoginService,
    private analyticsService: AnalyticsService
  ) {}

  onConsentYesChange() {
    if (this.consentYes) {
      this.consentNo = false;
    }
  }

  onConsentNoChange() {
    if (this.consentNo) {
      this.consentYes = false;
    }
  }

  ngOnInit(): void {
    this.loadCities();
    this.route.params.subscribe((params) => {
      this.param = params["key"];
      this.SettingsService.getClinic(this.param).subscribe(async (data: any) => {
        if (data.error) {
          return (this.GID = null);
        }
        this.route.queryParams.subscribe((queryParams) => {
          if (queryParams["message"] === "true") {
            this.onlyMessage = true;
            this.showMessageGeneral = true;
          }
        });
        this.GID = data.GID;

        this.isCardio = data.isCardio;
        this.loginService.isCardio = data.isCardio;

        this.isGastro = data.isGastro;
        this.loginService.isGastro = data.isGastro;

        this.isEyes = data.isEyes;
        this.loginService.isEyes = data.isEyes;

        this.clinicUsers = data.users;
        this.clinicTitle = data.clinicTitle;
        this.isObgyn = this.isCardio || this.isEyes || this.isGastro ? false : true;
        this.hasSeparation = data.hasSeparation;
        this.clinicPhone = data.phone;
        if (data["printHeaderWithGid"]) {
          this.showHeader = true;
          this.altHeader = this.sanitizer.bypassSecurityTrustHtml(data["printHeaderWithGid"]);
        }
        this.clinicExamTypes = await this.SettingsService.getExams(this.GID);
        this.clinicUsers.forEach((doc) => {
          this.fetchActivityHours(doc["UID"], this.GID);
        });
        this.fetchAvailableHMOs();
      });
    });
  }

  resetMessage() {
    this.showMessage = false;
    this.Message = null;
  }

  orderExamsByCategories() {
    this.GynecologyExams = this.clinicExamTypes.filter((exam) => {
      const hmo = this.hmo == "Private" ? "Private" : this.HMOName;
      return exam["category"] == "Gynecology" && exam[hmo] && this.passesCodeFilter(exam);
    });
    this.PregnancyExams = this.clinicExamTypes.filter((exam) => {
      const hmo = this.hmo == "Private" ? "Private" : this.HMOName;
      return exam["category"] == "Pregnancy" && exam[hmo] && this.passesCodeFilter(exam);
    });
    this.FetalEchoExams = this.clinicExamTypes.filter((exam) => {
      const hmo = this.hmo == "Private" ? "Private" : this.HMOName;
      return exam["category"] == "Fetal Echo" && exam[hmo] && this.passesCodeFilter(exam);
    });
    this.PediatricEchoExams = this.clinicExamTypes.filter((exam) => {
      const hmo = this.hmo == "Private" ? "Private" : this.HMOName;
      return exam["category"] == "Pediatric Echo" && exam[hmo] && this.passesCodeFilter(exam);
    });
    this.CardioExams = this.clinicExamTypes.filter((exam) => {
      const hmo = this.hmo == "Private" ? "Private" : this.HMOName;
      return exam["category"] == "Cardio" && exam[hmo] && this.passesCodeFilter(exam);
    });
  }

  fetchAvailableHMOs() {
    this.SettingsService.getAvailableHMOs(this.GID).subscribe({
      next: (response: any) => {
        this.hmoOptions = response.availableHMOs;
      },
      error: (error) => {
        console.error("Error fetching HMOs", error);
      },
    });
  }

  onHmoChange(newHmo: string) {
    this.resetMessage();
    if (newHmo === "Private") {
      this.examCategory = this.previousExamCategory;
    } else {
      this.previousExamCategory = this.examCategory;
      this.examCategory = "";
    }
    this.hmo = newHmo;
  }

  searchPatient() {
    this.invalidId = false;
    if (!this.IDValidator()) {
      this.idAttemptsCounter += 1;
      return (this.invalidId = true);
    }
    this.PatientsService.getPatients(
      this.GID,
      this.ID,
      undefined,
      undefined,
      undefined,
      undefined,
      (patients: Patient[]) => {
        let pat = new Patient();
        pat.asignVals(patients[0]);
        this.patient = pat;
        // this.showFirstName=true
        if (this.patient.PID) {
          this.assignPatVals(this.patient);
          this.SettingsService.IdentityVerification(this.patient.PID).subscribe((data) => {
            if (data["error"]) return (this.mobileError = true);
            this.showVerification = true;
            this.mobileError = false;
            this.mobile = data["Mobile"];
            this.verificationIndex = data["autoIndex"];
            this.patient.First = data["First"];
          });
        } else {
          this.showMobile = true;
        }
      }
    );
  }

  IdentityVerification() {
    this.SettingsService.IdentityVerification(undefined, this.mobile).subscribe((data) => {
      if (data["error"]) {
        this.codeMobileAttemptsCounter += 1;
        return (this.mobileError = true);
      }

      this.showVerification = true;
      this.mobileError = false;
      this.verificationIndex = data["autoIndex"];
    });
  }

  isValidMobile(mobile: string): boolean {
    return mobile?.length === 10 && mobile.startsWith("05") && /^[0-9]+$/.test(mobile);
  }

  IDValidator() {
    let id: any = this.ID.replace("-", "");
    if (id.length < 9 || isNaN(id)) {
      // Make sure ID is formatted properly
      return false;
    }
    let sum = 0,
      incNum;
    for (let i = 0; i < id.length; i++) {
      incNum = Number(id[i]) * ((i % 2) + 1); // Multiply number by 1 or 2
      sum += incNum > 9 ? incNum - 9 : incNum; // Sum the digits up and add to total
    }
    return sum % 10 === 0;
  }

  showAllPatInput() {
    this.showAddress = true;
    this.showBirth = true;
    this.showLastName = true;
    this.showMobile = true;
  }

  assignPatVals(patient) {
    this.address = patient.Address;
    this.mobile = patient.Mobile;
    this.firstName = patient.First;
    this.lastName = patient.Last;
    // Check if patient has already provided SMS consent
    this.showSmsConsent = true;
    if (patient.SmsConsent !== null && patient.SmsConsent !== undefined) {
      this.consentYes = patient.SmsConsent === true || patient.SmsConsent === 1;
      this.consentNo = patient.SmsConsent === false || patient.SmsConsent === 0;
    } else {
      this.consentYes = true;
      this.consentNo = false;
    }
  }

  resetAll() {
    this.address = null;
    this.mobile = null;
    this.firstName = null;
    this.lastName = null;
    this.birthDate = null;
    this.showAddress = false;
    this.showBirth = false;
    this.showLastName = false;
    this.showMobile = false;
    this.showFirstName = false;
    this.patient = null;
    this.invalidId = false;
    this.verification = null;
    this.showVerification = false;
    this.mobileError = false;
    this.verificationIndex = null;
    this.verificationValid = "pending";
    this.Message = null;
    this.showMessage = false;
    this.consentYes = true;
    this.consentNo = false;
    this.showSmsConsent = true;
    this.firstExam = null;
    this.isFirstExamAnswered = null;
    this.isPrevExamHmoAnswered = null;
    this.prevExamHmo = null;
    this.isprevExamHmoRefundAnswered = null;
    this.prevExamHmoRefund = null;
  }

  switchExamCategory(category) {
    this.LMP = null;
    this.examTypeSelected = null;
    this.filteredUsers = [];
    this.Fetus = null;
    this.Price = null;
    this.showPriceError = false;
    this.resetMessage();
    this.filterdClinicExamTypeAfterUserSelectCategory = this.clinicExamTypes.filter((exam) => {
      const hmo = this.hmo == "Private" ? "Private" : this.HMOName;
      return exam["category"] == category && exam[hmo] && this.passesCodeFilter(exam);
    });

    if (this.examCategory == "Fetal Echo") return;
    if (this.filterdClinicExamTypeAfterUserSelectCategory.length == 1) {
      this.examTypeSelected = this.filterdClinicExamTypeAfterUserSelectCategory[0].AutoIndex;
      this.onExamTypeChange();
    }
  }

  getExamType(selectedExamType: string): string {
    const exam = this.filterdClinicExamTypeAfterUserSelectCategory.find(
      (e) => e.AutoIndex == selectedExamType
    );
    return exam ? exam.examType : "";
  }

  onExamTypeChange(): void {
    this.firstExamRequired =
      this.examTypeSelected &&
      this.hmo === "Hmo" &&
      this.getExamType(this.examTypeSelected) === "Late Anatomy";
    this.resetMessage();
    this.Price = null;
    this.Fetus = null;
    this.firstExam = null;
    this.isFirstExamAnswered = null;
    this.isPrevExamHmoAnswered = null;
    this.prevExamHmo = null;
    this.isprevExamHmoRefundAnswered = null;
    this.prevExamHmoRefund = null;
    this.showPriceError = false;
    const selectedExam = this.clinicExamTypes.find((exam) => exam.AutoIndex == this.examTypeSelected);
    this.lmpValid = true;

    if (this.LMP && selectedExam) {
      const lmpDate = new Date(this.LMP);
      const maxWeeks = selectedExam.maxWeeks;
      const maxDays = selectedExam.maxDays;
      let maxDate = null;

      if (maxWeeks || maxDays) {
        const weeksInMs = maxWeeks ? maxWeeks * 7 * 24 * 60 * 60 * 1000 : 0;
        const daysInMs = maxDays ? maxDays * 24 * 60 * 60 * 1000 : 0;
        maxDate = new Date(lmpDate.getTime() + weeksInMs + daysInMs);
      }

      if (maxDate && maxDate < new Date()) {
        const translatedExamName = this.translate.instant(
          `exam.type.appointments.${selectedExam.examType}`
        );
        alert(`גיל ההריון אינו מתאים לסוג הבדיקה שנבחרה: ${translatedExamName}`);
        this.lmpValid = false;
        return;
      }
    }

    this.checkAvailableSlotsRange();

    // if (selectedExam) {
    //   this.filteredUsers = this.clinicUsers.filter((user) => selectedExam.users.includes(user.UID));
    //   if (this.filteredUsers.length == 1) {
    //     this.doctorSelected = this.filteredUsers[0].UID;
    //     this.checkAvailableSlotsRange();
    //   } else {
    //     this.doctorSelected = null;
    //   }
    // } else {
    //   this.filteredUsers = [];
    // }
  }

  onLmpChange() {
    if (this.filterdClinicExamTypeAfterUserSelectCategory.length == 1) {
      this.examTypeSelected = this.filterdClinicExamTypeAfterUserSelectCategory[0].AutoIndex;
      this.onExamTypeChange();
      return;
    }
    if (this.LMP && this.examTypeSelected) {
      const selectedExam = this.clinicExamTypes.find((exam) => exam.AutoIndex == this.examTypeSelected);
      this.lmpValid = true;

      if (this.LMP && selectedExam) {
        const lmpDate = new Date(this.LMP);
        const maxWeeks = selectedExam.maxWeeks;
        if (maxWeeks) {
          const maxDate = new Date(lmpDate.getTime() + maxWeeks * 7 * 24 * 60 * 60 * 1000); // Calculate max date
          if (maxDate < new Date()) {
            const translatedExamName = this.translate.instant(
              `exam.type.appointments.${selectedExam.examType}`
            );
            alert(`גיל ההריון אינו מתאים לסוג הבדיקה שנבחרה: ${translatedExamName}`);
            this.lmpValid = false;
            return;
          }
        }
        this.checkAvailableSlotsRange();
      }
    }
  }

  async savePatientAndRedirectToBooking() {
    if (this.patient.PID) {
      const appointmentExists = await this.checkExistingAppointment();
      if (appointmentExists) {
        return;
      }
    }

    if (!this.GID || !this.ID || !this.examTypeSelected) {
      return;
    }
    if (!this.patient.PID) {
      if (!this.firstName || !this.lastName || !this.mobile || !this.birthDate) {
        return;
      }
    }
    let modifiedLMP = this.LMP;
    if (this.LMP) {
      // add 6 hours to date for save this day and not the day before
      const lmpDate = new Date(this.LMP);
      lmpDate.setHours(lmpDate.getHours() + 6);
      modifiedLMP = lmpDate;
    }
    const body = {
      GID: this.GID,
      ID: this.ID,
      First: this.firstName,
      Last: this.lastName,
      Birth: this.birthDate || null,
      Mobile: this.mobile,
      LMP: modifiedLMP,
      Address: this.address,
      UID: this.doctorSelected,
      PID: this.patient.PID,
      hasSeparation: this.hasSeparation,
      City: this.City,
      Zip: this.Zip,
      SmsConsent: this.consentYes ? 1 : 0,
    };

    if (this.hmo == "Hmo") {
      if (this.HMOName) {
        body["HMOName"] = this.HMOName;
      }
      if (this.Insurance) {
        body["Insurance"] = this.Insurance;
      }
    }
    this.PatientsService.patientUpdateOrCreate(body).subscribe((data) => {
      const u = data["u"];
      const p = data["p"];
      const g = this.param;
      const e = this.examTypeSelected;
      const h = this.hmo;
      const queryParams = { g, u, p, e, h };
      if (this.Fetus) {
        queryParams["F"] = this.Fetus;
      }
      if (this.hmo == "Hmo") {
        queryParams["i"] = this.Insurance;
        queryParams["hmo"] = this.HMOName;
      }
      const urlTree = this.router.createUrlTree(["/booking"], { queryParams });
      const url = this.router.serializeUrl(urlTree);
      window.open(url, "_blank");
    });
  }

  updateAppointmentDate(appointment) {
    const a = appointment["AutoIndex"];
    const u = appointment["DocUID"];
    const p = appointment["PID"];
    const g = this.param;
    const e = appointment.examTypeID;
    const h = appointment["Funding"];
    const queryParams = { a, g, u, p, e, h };
    if (appointment["Fetus"]) {
      queryParams["f"] = appointment["Fetus"];
    }
    const urlTree = this.router.createUrlTree(["/booking"], { queryParams });
    const url = this.router.serializeUrl(urlTree);
    window.open(url, "_blank");
  }

  checkVerification(code, codeId = this.verificationIndex) {
    this.verificationValid = true;
    this.SettingsService.checkVerification(code, codeId).subscribe(async (data) => {
      if (data["status"] == "ok") {
        if (this.patient.PID) {
          // existing patient
          this.firstScreen = false;
          this.verificationValid = "valid";
          await this.getPatAppointments();
          await this.getPatActivities();
          if (this.patient.PID) {
            this.analyticsService.updateVisit({ PID: this.patient.PID, ID: this.ID }).subscribe({
              next: () => {
                // console.log("[Attribution] PID & ID attached");
              },
            });
          }
          if (this.appointments && this.appointments.length) {
            this.showAppointmentsScreen = true;
            return;
          }
          this.secondScreen = true;
        } else {
          // new patient
          this.analyticsService.updateVisit({ ID: this.ID }).subscribe({
            next: () => {
              // console.log("[Attribution] ID attached");
            },
          });
          this.showFirstName = true;
        }

        return;
      }
      this.codeMobileAttemptsCounter += 1;
      this.verificationValid = false;
    });
  }

  async getPatAppointments() {
    try {
      const appointments = await this.PatientsService.getAppointments(this.patient.PID, this.GID);
      this.appointments = appointments["current"];
      return this.appointments;
    } catch (error) {
      this.appointments = [];
      return this.appointments;
    }
  }

  async getPatActivities() {
    try {
      const patActivities = await this.SettingsService.patientActivities(this.GID, this.patient.PID);
      this.patActivities =
        Array.isArray(patActivities) && patActivities.length ? patActivities.length : 0;
      this.popupActivityDeviation = this.patActivities > 3 ? true : false;
      return this.patActivities;
    } catch (err) {
      this.patActivities = 0;
    }
  }

  onBackButtonClick() {
    if (this.secondScreen) {
      if (this.appointments && this.appointments.length) {
        this.showAppointmentsScreen = true;
        this.getPatAppointments();
        this.secondScreen = false;
      } else {
        this.secondScreen = false;
        this.firstScreen = true;
      }
    } else if (this.endScreen) {
      this.endScreen = false;
      this.secondScreen = true;
    } else if (this.showAppointmentsScreen) {
      this.firstScreen = true;
      this.showAppointmentsScreen = false;
    }
  }

  lmpGA(lmp) {
    if (!lmp) return "";
    let dt = new Date();
    let days = Math.floor((dt.getTime() - Date.parse(lmp)) / (1000 * 60 * 60 * 24));
    if (Math.floor(days / 7) > 50) return "";
    return Math.floor(days / 7) + "w " + (Math.floor(days) % 7) + "d";
  }

  async checkAvailableSlotsRange() {
    this.resetMessage();

    if (this.patient.PID) {
      const appointmentExists = await this.checkExistingAppointment();
      if (appointmentExists) {
        return;
      }
    }

    const today = new Date();
    let minDate = new Date(today.getTime() + 2 * 24 * 60 * 60 * 1000);
    let maxDate = new Date(minDate);
    maxDate.setMonth(maxDate.getMonth() + 3);

    let exam = this.clinicExamTypes.find((exam) => exam.AutoIndex == this.examTypeSelected);
    let duration = exam.Length;

    if (
      this.SettingsService.categories["Pregnancy"].includes(exam.examType) ||
      this.SettingsService.categories["Fetal Echo"].includes(exam.examType)
    ) {
      if (!this.Fetus) return;
      const lmpDate = new Date(this.LMP);
      const maxWeeks = exam.maxWeeks;
      const maxDays = exam.maxDays;
      const minWeeks = exam.minWeeks;
      const minDays = exam.minDays;

      if (maxWeeks || maxDays) {
        const weeksInMs = maxWeeks ? maxWeeks * 7 * 24 * 60 * 60 * 1000 : 0;
        const daysInMs = maxDays ? maxDays * 24 * 60 * 60 * 1000 : 0;
        maxDate = new Date(lmpDate.getTime() + weeksInMs + daysInMs);
      }

      if (minWeeks || minDays) {
        const weeksInMs = minWeeks ? minWeeks * 7 * 24 * 60 * 60 * 1000 : 0;
        const daysInMs = minDays ? minDays * 24 * 60 * 60 * 1000 : 0;
        minDate = new Date(lmpDate.getTime() + weeksInMs + daysInMs);

        // Ensure minDate is at least 2 days from today
        if (today > minDate) {
          minDate = new Date(today.getTime() + 2 * 24 * 60 * 60 * 1000);
        }
      }
      if (this.Fetus == "2") {
        duration = exam.LengthTwins;
      }
    }

    await this.getSlotsRange(
      this.setStartOfDay(minDate),
      this.setEndOfDay(maxDate),
      this.GID,
      duration,
      exam.AutoIndex
    );

    // await this.getSlotsRange(
    //   this.setStartOfDay(minDate),
    //   this.setEndOfDay(maxDate),
    //   this.GID,
    //   this.doctorSelected,
    //   duration,
    //   this.activityHours[this.doctorSelected]
    // );
  }

  async checkExistingAppointment(): Promise<boolean> {
    this.showExistingAppointmentMsg = false;
    await this.getPatAppointments();

    let matchedExam = null;
    let matchedAppointment = null;

    matchedExam = this.clinicExamTypes.find((exam) => {
      return exam.AutoIndex == this.examTypeSelected;
    });

    if (matchedExam.custom) {
      matchedAppointment = this.appointments.filter(
        (appointment) => appointment.examType === matchedExam.examType
      );
    } else {
      matchedAppointment = this.appointments.filter(
        (appointment) => appointment.examName === matchedExam.examName
      );
    }
    if (matchedAppointment.length > 0) {
      this.showExistingAppointmentMsg = true;
      this.existingAppointmentMsg = `תור לבדיקה מסוג זה קיים כבר. באפשרותך להזיז את התור או לבטל אותו.`;
      return true;
    } else {
      this.showExistingAppointmentMsg = false;
      this.existingAppointmentMsg = ``;
      return false;
    }
  }

  resetExitingAppointmentMessage() {
    this.examTypeSelected = null;
    this.showExistingAppointmentMsg = false;
    this.existingAppointmentMsg = ``;
  }

  setStartOfDay(date: Date): Date {
    const startOfDay = new Date(date);
    startOfDay.setHours(3, 0, 0, 0); // Set time to 00:00:00.000
    return startOfDay;
  }

  setEndOfDay(date: Date): Date {
    const endOfDay = new Date(date);
    endOfDay.setHours(23, 59, 59, 999); // Set time to 23:59:59.999
    return endOfDay;
  }

  // async getSlotsRange(
  //   minDate: Date,
  //   maxDate: Date,
  //   gid: string,
  //   uid: string,
  //   slotsLength: number,
  //   activityHours: any
  // ) {
  async getSlotsRange(minDate: Date, maxDate: Date, GID: string, slotsDuration: number, examType) {
    this.slotsAvailable = "Loading";
    this.appointmentService
      .searchAvailableSlots({ minDate, maxDate, GID, slotsDuration, examType, byRoom: true })
      .subscribe({
        next: (response: any) => {
          if (!response.slots || !Object.keys(response.slots).length) {
            this.slotsAvailable = false;
          } else {
            this.slotsAvailable = "ok";
            this.calculateAppointmentPrice();
          }
        },
        error: (error) => {
          this.slotsAvailable = false;
        },
      });
    // this.SettingsService.getSlotsRange(
    //   minDate,
    //   maxDate,
    //   gid,
    //   uid,
    //   slotsLength,
    //   activityHours,
    //   this.hmo == "Hmo" && this.HMOName ? this.HMOName : null
    // ).subscribe({
    //   next: (response: any) => {
    //     if (!response.slots || !Object.keys(response.slots).length) {
    //       this.slotsAvailable = false;
    //     } else {
    //       this.slotsAvailable = "ok";
    //       this.calculateAppointmentPrice();
    //     }
    //   },
    //   error: (error) => {
    //     this.slotsAvailable = false;
    //   },
    // });
  }

  fetchActivityHours(UID, GID): void {
    this.SettingsService.getActivityHours(UID, GID).subscribe({
      next: (data) => {
        this.activityHours[UID] = data;
      },
      error: (err) => console.error("Failed to fetch activity hours", err),
    });
  }

  calculateAppointmentPrice() {
    this.Price = null;
    this.showPriceError = false;
    this.showMobile = false;
    if ((this.examCategory == "Pregnancy" || this.examCategory == "Fetal Echo") && !this.Fetus) return;
    if (this.examCategory == "Gynecology") {
      this.Fetus = null;
    }
    let exam = this.clinicExamTypes.find((exam) => exam.AutoIndex == this.examTypeSelected);
    const appointmentData = {
      UID: this.doctorSelected,
      GID: this.GID,
      examTypeId: exam.AutoIndex,
      Funding: this.hmo,
      Fetus: this.Fetus,
    };
    if (this.hmo == "Hmo") {
      appointmentData["Insurance"] = this.Insurance;
      appointmentData["HMOName"] = this.HMOName;
    }
    this.appointmentService
      .calcAppointmentPrice(appointmentData)
      .pipe(
        catchError((error) => {
          return of({ price: null });
        })
      )
      .subscribe((data) => {
        if (data["price"]) {
          this.Price = data["price"];
        } else {
          this.Price = null;
          this.showPriceError = true;
        }
      });
  }

  leftDetails(onlyMessage = false) {
    let modifiedLMP = this.LMP;
    if (this.LMP) {
      // add 6 hours to date for save this day and not the day before
      const lmpDate = new Date(this.LMP);
      lmpDate.setHours(lmpDate.getHours() + 6);
      modifiedLMP = lmpDate;
    }
    let exam = this.clinicExamTypes.find((exam) => exam.AutoIndex == this.examTypeSelected);
    const body = {
      GID: this.GID,
      ID: this.ID,
      First: this.firstName,
      Last: this.lastName,
      Birth: this.birthDate || null,
      Mobile: this.mobile,
      LMP: modifiedLMP,
      Address: this.address,
      UID: this.doctorSelected,
      PID: this.patient.PID,
      hasSeparation: this.hasSeparation,
      City: this.City,
      Zip: this.Zip,
      HMO: this.hmo,
      ExamType: exam && exam.custom ? exam.examType : exam?.examName,
      Message: this.Message,
      SmsConsent: this.consentYes ? 1 : (this.consentNo ? 0 : null),
    };
    if (this.hmo == "Hmo") {
      if (this.HMOName) {
        body["HMO"] = this.HMOName;
      }
    }
    if (onlyMessage) {
      body["onlyMessage"] = true;
    }
    this.PatientsService.savePatientTemporary(body).subscribe((result) => {
      if (result["status"] == "ok") {
        if (result["patMsgId"]) {
          this.analyticsService.updateVisit({ patMsgId: result["patMsgId"] }).subscribe({
            next: () => {
              // console.log("[Attribution] patMsgId attached");
            },
          });
        }
        this.endScreen = true;
        this.secondScreen = false;
        this.showAppointmentsScreen = false;
        this.showMessageGeneral = false;
        this.msgSaved = true;
      }
    });
  }

  async deleteAppointment(appointmentId) {
    try {
      const result = await this.appointmentService.delete(appointmentId, this.GID);
      if (result) {
        await this.getPatAppointments();
      }
    } catch (error) {
      this.popUpMessage = error["error"]["error"];
      console.error("Error during the deletion process:", error);
    }
  }

  isFutureAppointment(aptTime: string | Date): boolean {
    const appointmentDate = new Date(aptTime);
    const tomorrow = new Date();
    tomorrow.setHours(0, 0, 0, 0);
    tomorrow.setDate(tomorrow.getDate() + 1);
    return appointmentDate >= tomorrow;
  }

  setHmo(hmoValue: string): void {
    this.hmo = hmoValue;
    this.resetAfterHmo();
  }

  resetAfterHmo(): void {
    this.HMOName = null;
    this.Insurance = null;
    this.examCategory = null;
    this.LMP = null;
    this.examTypeSelected = null;
    this.doctorSelected = null;
    this.Fetus = null;
    this.slotsAvailable = null;
    this.showMessage = false;
    this.Message = null;
    this.Price = null;
    this.showMobile = false;
    this.showPriceError = false;
    this.firstExam = null;
    this.isFirstExamAnswered = null;
    this.firstExamRequired = null;
    this.isPrevExamHmoAnswered = null;
    this.prevExamHmo = null;
    this.isprevExamHmoRefundAnswered = null;
    this.prevExamHmoRefund = null;
    this.hasCodeAnswer = null;
    this.examCodeInput = '';
    this.examCodeError = '';
    this.codeValidating = false;
  }

  // True when the exam should be shown for the current code answer (hide coded exams when patient has no code).
  passesCodeFilter(exam: any): boolean {
    if (this.hasCodeAnswer !== 'no') return true;
    const codeKey = (this.hmo === 'Private' ? 'Private' : this.HMOName) + 'HasCode';
    return !exam[codeKey];
  }

  setHasCode(answer: 'yes' | 'no'): void {
    this.hasCodeAnswer = answer;
    this.examCodeInput = '';
    this.examCodeError = '';
    this.examTypeSelected = null;
    this.examCategory = null;
    this.slotsAvailable = null;
    this.resetMessage();
    this.orderExamsByCategories();
  }

  async submitExamCode(): Promise<void> {
    this.examCodeError = '';
    const code = (this.examCodeInput || '').trim();
    if (!code) return;
    const hmoKey = this.hmo === 'Private' ? 'Private' : this.HMOName;
    this.codeValidating = true;
    try {
      const res = await this.SettingsService.validateExamCode(this.GID, hmoKey, code);
      if (res && res.valid) {
        this.examTypeSelected = res.examTypeId;
        const exam = this.clinicExamTypes.find((e) => e.AutoIndex == res.examTypeId);
        if (exam) {
          if (exam.category) this.examCategory = exam.category;
          this.filterdClinicExamTypeAfterUserSelectCategory = [exam];
        }
        this.onExamTypeChange();
      } else {
        this.examTypeSelected = null;
        this.slotsAvailable = null;
        this.examCodeError = `הקוד אינו תואם. נא לפנות למזכירות בטלפון ${this.clinicPhone || ''}`;
      }
    } catch (e) {
      this.examTypeSelected = null;
      this.slotsAvailable = null;
      this.examCodeError = `הקוד אינו תואם. נא לפנות למזכירות בטלפון ${this.clinicPhone || ''}`;
    } finally {
      this.codeValidating = false;
    }
  }

  savePatientsAbandonedProcesses(Reason) {
    let modifiedLMP = this.LMP;
    if (this.LMP) {
      // add 6 hours to date for save this day and not the day before
      const lmpDate = new Date(this.LMP);
      lmpDate.setHours(lmpDate.getHours() + 6);
      modifiedLMP = lmpDate;
    }
    let exam = this.clinicExamTypes.find((exam) => exam.AutoIndex == this.examTypeSelected);
    const body = {
      GID: this.GID,
      ID: this.ID,
      First: this.firstName,
      Last: this.lastName,
      Birth: this.birthDate || null,
      Mobile: this.mobile,
      LMP: modifiedLMP,
      Address: this.address,
      UID: this.doctorSelected,
      PID: this.patient.PID,
      hasSeparation: this.hasSeparation,
      City: this.City,
      Zip: this.Zip,
      HMO: this.hmo,
      ExamType: exam && exam.custom ? exam.examType : exam?.examName,
      Reason,
      SmsConsent: this.consentYes ? 1 : (this.consentNo ? 0 : null),
    };
    this.PatientsService.savePatientsAbandonedProcesses(body).subscribe((result) => {
      if (result["status"] == "ok") {
        if (result["patAbandonedId"]) {
          this.analyticsService.updateVisit({ patAbandonedId: result["patAbandonedId"] }).subscribe({
            next: () => {
              // console.log("[Attribution] patMsgId attached");
            },
          });
        }
      }
    });
  }

  onShowMessage() {
    this.showMessage = true;

    // Wait for the DOM to update before scrolling
    setTimeout(() => {
      this.messageDiv?.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 0);
  }

  onShowMessageGeneral() {
    this.showMessageGeneral = true;

    // Wait for the DOM to update before scrolling
    setTimeout(() => {
      this.messageGeneral?.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 0);
  }

  handleEnter() {
    if (this.idAttemptsCounter < 4) {
      this.resetAll();
      this.searchPatient();
    }
  }

  
  loadCities(): void {
    this.cities = CITIES;
    this.filteredCities = CITIES;
  }

  selectCity(city: string): void {
    setTimeout(() => {
      this.City = city;
      this.citySearchInput = city;
      this.filteredCities = [];
    }, 0);
  }

  onCityBlur(): void {
    // Use setTimeout to allow click events on dropdown items to process first
    setTimeout(() => {
      // If the input value is not in the cities list, clear it
      if (this.citySearchInput && !this.cities.includes(this.citySearchInput)) {
        this.citySearchInput = "";
        this.City = "";
      }
      this.filteredCities = [];
    }, 100);
  }

  onCityInput(event: any): void {
    const searchTerm = event.target.value;
    this.citySearchInput = searchTerm;
    this.filterCities(searchTerm);
  }

  
  filterCities(searchTerm: string): void {
    if (!searchTerm) {
      this.filteredCities = this.cities;
    } else {
      // First, get cities that start with the search term
      const startsWith = this.cities.filter((city) =>
        city.startsWith(searchTerm),
      );
      // Then, get cities that contain the search term but don't start with it
      const contains = this.cities.filter(
        (city) => city.includes(searchTerm) && !city.startsWith(searchTerm),
      );
      // Combine: cities starting with search term first, then others
      this.filteredCities = [...startsWith, ...contains];
    }
  }
}
